"use strict";

exports.__esModule = true;
exports.shouldEnableSwitchPlant = void 0;
var shouldEnableSwitchPlant = exports.shouldEnableSwitchPlant = function shouldEnableSwitchPlant(permissions) {
  var plantAccessRegex = new RegExp("^plants:access:");
  return permissions.includes("plants:access:*") || permissions.filter(function (perm) {
    return plantAccessRegex.test(perm);
  }).length > 1;
};